<div class="all-in-one-table content-layout">
  <calsoft-page-header *ngIf="type==1" [height]="'180px'" background="url(assets/images/headers/pattern-3.png)"
    [reverse]="true">
  </calsoft-page-header>

  <div class="container">
    <calsoft-breadcrumbs *ngIf="type==1 && GridType !=  8" [url]="'google-calender'" [currentPage]="'Meeting'"
      [header]="'primary'">
    </calsoft-breadcrumbs>

    <div *ngIf="GridType !=  8">
      <calsoft-list [progress]="spinner" (filterChangeColumn)="onFilterChangeColumn($event)"
        [filterSelectObj]="filterSelectObj" name="Meeting" [columns]="columns" (filterChange)="onFilterChange($event)">

        <div class="actions" fxFlexAlign="center">


          <button [attr.guide]="'google-calendar-service-account-btn-1' + '__' + sanitizedUrl" mat-button
            [matMenuTriggerFor]="menu">
            <mat-icon>view_headline</mat-icon>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>


          <button [attr.guide]="'google-calendar-service-account-btn-2' + '__' + sanitizedUrl"
            [disabled]="!resourcePrivilege?.create" class="create" (click)="addGoogleCalendar()" matTooltip="User Group"
            type="button" mat-mini-fab color="primary">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <mat-menu [overlapTrigger]="false" xPosition="before" #menu="matMenu">

          <a [attr.guide]="'google-calendar-service-account-lnk-3' + '__' + sanitizedUrl" mat-menu-item
            (click)="importExcel()">
            <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
            <span>Import-Excel</span>
          </a>

          <div class="open">
            <a [attr.guide]="'lead-call-over-view-report-lnk-2' + '__' + sanitizedUrl" mat-menu-item
              (click)="exportDataFilter()">
              <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
              <span>Download</span>
            </a>
          </div>

        </mat-menu>
        <div *ngIf="read" [ngClass]="elements>5?'example-container':'none'" style="overflow-x:auto;">
          <mat-table #table [dataSource]="googleCalendarList" matSort (matSortChange)="sortData($event)"
            style="user-select:none">
            <!-- fullName Column -->
            <ng-container *ngFor="let column of columns">
              <ng-container *ngIf="column.isModelProperty" [matColumnDef]="column.property">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.name }}</mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row[column.property] }}</mat-cell>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="createdDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{row.startDateTime | calsoftDate}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="startDateTime">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Scheduled Date</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{row.startDateTime | calsoftDate}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="endDateTime">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Meeting End Time</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <!-- {{row.endTime}} --> {{ ('1970-01-01T' + row.endTime + ':00') | date:'h : mm a' }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="startTime">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Meeting Start Time</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ formatTime12(row.startTime) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="meetLink">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Link</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <!-- {{row.meetLink}} -->
                <button *ngIf="row.meetLink"
                  [attr.guide]="'google-calendar-service-account-btn-4' + '__' + sanitizedUrl"
                  (click)="copyToClipboard(row.meetLink)">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="error">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Error</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <div class="description-header" (click)="toggleError(row)" *ngIf="row.error">
                  <span class="description-text" [class.expanded]="row.showFullError"
                    style="white-space: pre-line; word-break: break-word;">
                    {{ row.error }}
                  </span>
                  <span class="material-icons-outlined arrow-icon" [class.open]="row.showFullError">
                    keyboard_arrow_down
                  </span>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="updatedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{row.updatedDate | calsoftDate}}
              </mat-cell>
            </ng-container>
            <!-- actions Column -->
            <ng-container matColumnDef="actions">
              <mat-header-cell class="actions-cell" *matHeaderCellDef>Action</mat-header-cell>
              <mat-cell class="actions-cell" *matCellDef="let row">
                <button [attr.guide]="'google-calendar-service-account-btn-5' + '__' + sanitizedUrl" type="button"
                  mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                  <button [attr.guide]="'google-calendar-service-account-btn-6' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.update" (click)="editGoogleCalendar(row.googleCalenderId)"
                    mat-menu-item>
                    <mat-icon>edit</mat-icon>
                    <span>edit</span>
                  </button>
                  <button [attr.guide]="'google-calendar-service-account-btn-7' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.delete" (click)="deleteCalenderById(row.googleCalenderId)"
                    mat-menu-item>
                    <mat-icon>delete</mat-icon>
                    <span>delete</span>
                  </button>
                </mat-menu>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="visibleColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
            </mat-row>
          </mat-table>
        </div>
        <div class="products-padding" fxLayoutAlign="center center"
          *ngIf="googleCalendarList?.data?.length === 0 || googleCalendarList?.length === 0">
          No records found
        </div>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
          <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
          <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
            [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue"> </mat-paginator>
        </div>
      </calsoft-list>
    </div>

    <div *ngIf="GridType ==  8" class="table-responsive custom-table gridtable-class"
      [class.filter-open-layout]="isFilterPanelOpen || isFilterPanelColumnOpen" fxLayout="row" fxLayoutGap="16px"
      style="width: 100%; overflow: hidden; position: relative;">
      <div [fxFlex]="(isFilterPanelOpen || isFilterPanelColumnOpen) ? 'calc(100% - 366px)' : '100'"
        style="min-width: 0; transition: all 0.3s ease;">
        <div class="crm-container-new-eight">

          <main class="main-content">
            <section class="contacts-view">
              <div fxLayoutAlign="space-between center" class="contacts-header">

                <div class="user-role-header" fxLayoutAlign="start center">
                  <h2 class="sg-title">{{(currentRouterPath | moduleName) || 'Meeting'}}</h2>
                </div>

                <div class="contact-actions">
                  <button [attr.guide]="'google-calendar-service-account-btn-8' + '__' + sanitizedUrl"
                    class="btn btn-outline bhover" (click)="refresh()">
                    <mat-icon>refresh</mat-icon>
                    Refresh</button>

                  <button [attr.guide]="'google-calendar-service-account-btn-export-trigger' + '__' + sanitizedUrl"
                    class="btn btn-outline bhover" (click)="exportDataFilter()">
                    <mat-icon>file_download</mat-icon>
                    Export
                  </button>

                  <mat-menu [overlapTrigger]="false" xPosition="before" #exportMenu="matMenu">
                    <div class="open">
                      <a [attr.guide]="'lead-call-over-view-report-lnk-2' + '__' + sanitizedUrl" mat-menu-item
                        (click)="exportDataFilter()">
                        <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
                        <span>Download</span>
                      </a>
                    </div>
                  </mat-menu>

                  <button [attr.guide]="'google-calendar-service-account-btn-9' + '__' + sanitizedUrl"
                    class="btn btn-primary" (click)="addGoogleCalendar()"><mat-icon>add</mat-icon>
                    Add Google Calendar </button>
                </div>
              </div>

              <div class="table-controls-wrapper">

                <div class="table-controls">

                  <div class="contacts-header">
                    <div class="contact-actions">

                      <button [attr.guide]="'google-calendar-service-account-btn-10' + '__' + sanitizedUrl" mat-button
                        [matMenuTriggerFor]="viewMenu" class="btn-two btn-outline bhover">
                        <mat-icon>layers</mat-icon>
                      </button>

                      <mat-menu #viewMenu="matMenu">
                        <button [attr.guide]="'google-calendar-service-account-btn-11' + '__' + sanitizedUrl"
                          mat-menu-item (click)="setView('compact')">
                          <mat-icon>compress</mat-icon>
                          <span style="margin-left: 8px;">Compact</span>
                          <mat-icon *ngIf="viewMode === 'compact'" style="margin-left:5px;">check</mat-icon>
                        </button>
                        <button [attr.guide]="'google-calendar-service-account-btn-12' + '__' + sanitizedUrl"
                          mat-menu-item (click)="setView('comfortable')">
                          <mat-icon>expand</mat-icon>
                          <span style="margin-left: 8px;">Comfortable</span>
                          <mat-icon *ngIf="viewMode === 'comfortable'" style="margin-left:5px;">check</mat-icon>
                        </button>
                      </mat-menu>

                      <button [attr.guide]="'google-calendar-service-account-btn-13' + '__' + sanitizedUrl"
                        class="btn btn-outline bhover" [class.active-filter]="filterActive"
                        (click)="toggleFilterPanel()">
                        <mat-icon class="me-1">
                          {{ filterActive ? 'filter_alt' : 'filter_list' }}
                        </mat-icon>

                        <span>Filter</span>

                        <span *ngIf="filterActive" class="filter-pill">
                          <mat-icon class="pill-icon">check</mat-icon>
                        </span>
                      </button>
                      <button [attr.guide]="'google-calendar-service-account-btn-14' + '__' + sanitizedUrl"
                        class="btn btn-outline bhover" (click)="toggleFilterColumnPanel()"
                        [class.active-filter]="isFilterPanelColumnOpen">
                        Filter by Columns
                      </button>

                    </div>
                  </div>


                </div>

              </div>
              <div class="leads-content-area" [class.filter-open]="isFilterPanelOpen"
                [class.filter-column-open]="isFilterPanelColumnOpen">
                <div class="table-wrapper">

                  <table mat-table [dataSource]="googleCalendarList" matSort (matSortChange)="sortData($event)"
                    class="contacts-table" [ngClass]="viewMode">

                    <ng-container *ngFor="let col of columns; trackBy: trackByProp" [sticky]="!isMobile && col.isSticky"
                      [matColumnDef]="col.property">
                      <ng-container *ngIf="col.isModelProperty!='false'">

                        <ng-container *ngIf="col.property !== 'actions' && col.property !== 'action' ">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ col.name }}
                          </th>
                        </ng-container>
                        <ng-container *ngIf="col.property === 'actions' || col.property === 'action'">
                          <th mat-header-cell *matHeaderCellDef class="actions-cell">
                            {{ col.name }}
                          </th>
                        </ng-container>

                        <td mat-cell *matCellDef="let element ;let i = index" class="hover-cell">
                          <div class="cell-content-wrapper">
                            <div class="cell-data" style="padding-left: 15px;">

                              <ng-container [ngSwitch]="col.property">


                                <span *ngSwitchCase="'summary'">
                                  <ng-container *ngIf="editingCell?.rowId === element.googleCalenderId 
                               && editingCell?.colProperty === col.property; else nameReadMode">

                                    <input [attr.guide]="'google-calendar-service-account-inp-15' + '__' + sanitizedUrl"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.summary"
                                      placeholder="Enter summary" />

                                  </ng-container>

                                  <ng-template #nameReadMode>
                                    <div class="user-cell">
                                      <span class="name-cell">{{ element.summary ||
                                        '(No
                                        Name)' }}</span>
                                    </div>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'status'">
                                  <ng-container *ngIf="editingCell?.rowId === element.googleCalenderId 
                               && editingCell?.colProperty === col.property; else statusReadMode">

                                    <mat-select style="width: 100px;" *ngIf="col.inputType === 'select'"
                                      [(ngModel)]="element.status">

                                      <ng-container *ngIf="col.property == 'status'">
                                        <mat-option *ngFor="let item of status" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </ng-container>

                                    </mat-select>

                                  </ng-container>
                                  <ng-template #statusReadMode>
                                    <div class="user-cell1">
                                      <span>
                                        {{element.status }}
                                      </span>

                                    </div>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'createdDate'">
                                  <ng-container *ngIf="editingCell?.rowId === element.googleCalenderId 
                               && editingCell?.colProperty === col.property; else createdDateReadMode">

                                    <input [attr.guide]="'google-calendar-service-account-inp-16' + '__' + sanitizedUrl"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.createdDate"
                                      placeholder="Enter created Date" />

                                  </ng-container>

                                  <ng-template #createdDateReadMode>
                                    <div class="user-cell">
                                      <span class="name-cell">{{ element.createdDate | date:'dd-MM-yyyy' }}</span>
                                    </div>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'updatedDate'">
                                  <ng-container *ngIf="editingCell?.rowId === element.googleCalenderId 
                               && editingCell?.colProperty === col.property; else updatedDateReadMode">

                                    <input [attr.guide]="'google-calendar-service-account-inp-17' + '__' + sanitizedUrl"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.updatedDate"
                                      placeholder="Enter updated Date" />

                                  </ng-container>

                                  <ng-template #updatedDateReadMode>
                                    <div class="user-cell">
                                      <span class="name-cell">{{ element.updatedDate | date:'dd-MM-yyyy'}}</span>
                                    </div>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'startDateTime'">
                                  <ng-container *ngIf="editingCell?.rowId === element.googleCalenderId 
                               && editingCell?.colProperty === col.property; else startDateTimeReadMode">

                                    <input [attr.guide]="'google-calendar-service-account-inp-18' + '__' + sanitizedUrl"
                                      type="time" *ngIf="col.inputType === 'text'" matInput
                                      [(ngModel)]="element.startDateTime" placeholder="Enter start Date Time" />

                                  </ng-container>

                                  <ng-template #startDateTimeReadMode>
                                    <div class="user-cell">
                                      <span class="name-cell">{{ element.startDateTime | date:'dd-MM-yyyy' }}</span>
                                    </div>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'meetLink'">

                                  <button *ngIf="element.meetLink"
                                    [attr.guide]="'google-calendar-service-account-btn-19' + '__' + sanitizedUrl"
                                    (click)="copyToClipboard(element.meetLink)">
                                    <mat-icon>content_copy</mat-icon>
                                  </button>
                                </span>

                                <span *ngSwitchCase="'error'">
                                  <ng-container *ngIf="editingCell?.rowId === element.googleCalenderId 
                               && editingCell?.colProperty === col.property; else errorReadMode">

                                    <input
                                      [attr.guide]="'google-calendar-service-account-inp-error' + '__' + sanitizedUrl"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.error"
                                      placeholder="Enter error" />

                                  </ng-container>

                                  <ng-template #errorReadMode>
                                    <div class="description-header" (click)="toggleError(element)"
                                      *ngIf="element.error">
                                      <span class="description-text" [class.expanded]="element.showFullError"
                                        style="white-space: pre-line; word-break: break-word;">
                                        {{ element.error }}
                                      </span>
                                      <span class="material-icons-outlined arrow-icon"
                                        [class.open]="element.showFullError">
                                        keyboard_arrow_down
                                      </span>
                                    </div>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'endDateTime'">
                                  <ng-container *ngIf="editingCell?.rowId === element.googleCalenderId 
                               && editingCell?.colProperty === col.property; else endDateTimeReadMode">

                                    <input [attr.guide]="'google-calendar-service-account-inp-20' + '__' + sanitizedUrl"
                                      type="time" *ngIf="col.inputType === 'text'" matInput
                                      [(ngModel)]="element.endDateTime" placeholder="Enter end Date Time" />

                                  </ng-container>

                                  <ng-template #endDateTimeReadMode>
                                    <div class="user-cell">
                                      <span class="name-cell">{{ element.endDateTime | date:'h:mm a' }}</span>
                                    </div>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'startTime'">
                                  <ng-container *ngIf="editingCell?.rowId === element.googleCalenderId 
                               && editingCell?.colProperty === col.property; else startTimeReadMode">

                                    <input [attr.guide]="'google-calendar-service-account-inp-21' + '__' + sanitizedUrl"
                                      type="time" *ngIf="col.inputType === 'text'" matInput
                                      [(ngModel)]="element.startTime" placeholder="Enter end Date Time" />

                                  </ng-container>

                                  <ng-template #startTimeReadMode>
                                    <div class="user-cell">
                                      <span class="name-cell">{{ formatTime12(element.startTime) }}</span>
                                    </div>
                                  </ng-template>
                                </span>

                                <span *ngSwitchCase="'actions'">
                                  <button [attr.guide]="'google-calendar-service-account-btn-22' + '__' + sanitizedUrl"
                                    type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                                    (click)="$event.stopPropagation()">
                                    <mat-icon>more_horiz</mat-icon>
                                  </button>
                                  <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">

                                    <button
                                      [attr.guide]="'google-calendar-service-account-btn-23' + '__' + sanitizedUrl"
                                      [disabled]="!resourcePrivilege?.update"
                                      (click)="editGoogleCalendar(element.googleCalenderId)" mat-menu-item>
                                      <mat-icon>edit</mat-icon>
                                      <span>edit</span>
                                    </button>

                                    <button
                                      [attr.guide]="'google-calendar-service-account-btn-24' + '__' + sanitizedUrl"
                                      [disabled]="!resourcePrivilege?.delete"
                                      (click)="deleteCalenderById(element.googleCalenderId)" mat-menu-item>
                                      <mat-icon>delete</mat-icon>
                                      <span>Delete</span>
                                    </button>

                                  </mat-menu>

                                </span>



                                <span *ngSwitchDefault>
                                  <ng-container
                                    *ngIf="editingCell?.rowId === element.googleCalenderId 
                                                                        && editingCell?.colProperty === col.property; else readMode">

                                    <input [attr.guide]="'google-calendar-service-account-inp-25' + '__' + sanitizedUrl"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element[col.property]"
                                      placeholder="Enter value" />

                                  </ng-container>
                                  <ng-template #readMode>
                                    <span>
                                      {{ element[col.property] || '--' }}
                                    </span>
                                  </ng-template>
                                </span>

                              </ng-container>
                            </div>


                            <div *ngIf="col.property == 'edit1'" class="cell-actions">

                              <button
                                [attr.guide]="'google-calendar-service-account-btn-edit-value' + '__' + sanitizedUrl"
                                mat-icon-button
                                *ngIf="!(editingCell?.rowId === element.googleCalenderId && editingCell?.colProperty === col.property)"
                                aria-label="Edit value" class="icon-color icon-background">
                                <mat-icon
                                  (click)="startEdit(element.googleCalenderId, col.property, element, col); $event.stopPropagation()"
                                  style="font-size: 17px;">edit</mat-icon>
                              </button>

                              <button
                                [attr.guide]="'google-calendar-service-account-btn-save-value' + '__' + sanitizedUrl"
                                mat-icon-button
                                *ngIf="editingCell?.rowId === element.googleCalenderId && editingCell?.colProperty === col.property"
                                aria-label="Save value" class="icon-color icon-background">
                                <mat-icon
                                  (click)="saveEdit(element.googleCalenderId, col.property , element[col.property],element); $event.stopPropagation()"
                                  style="font-size: 17px;">check</mat-icon>
                              </button>

                              <button
                                [attr.guide]="'google-calendar-service-account-btn-save-value' + '__' + sanitizedUrl"
                                mat-icon-button
                                *ngIf="editingCell?.rowId === element.googleCalenderId && editingCell?.colProperty === col.property"
                                aria-label="Save value" class="icon-color icon-background">
                                <mat-icon
                                  (click)="closeEdit(element.googleCalenderId, col.property , element[col.property],element); $event.stopPropagation()"
                                  style="font-size: 17px;">close</mat-icon>
                              </button>


                            </div>
                          </div>
                        </td>


                      </ng-container>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></tr>
                    <tr mat-row *matRowDef="let row; columns: visibleColumns;">
                    </tr>

                  </table>
                  <div style="padding: 20px;" fxLayoutAlign="center center"
                    *ngIf="googleCalendarList?.data?.length === 0 || googleCalendarList?.length === 0">
                    No records found
                  </div>


                  <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
                    [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue"> </mat-paginator>

                </div>

              </div>


            </section>
          </main>
        </div>
      </div>

      <div class="side-form-container" *ngIf="isFilterPanelOpen">
        <div class="side-form-card mat-elevation-z4">
          <div
            style="flex: 1; display: flex; flex-direction: column; overflow-y: auto; overflow-x: hidden; min-height: 0;">
            <calsoft-filter-list-popup
              style="display: flex; flex-direction: column; flex: 1; min-height: 0; height: 100%;" [type]="2"
              [columns]="columns" [filterSelectObj]="filterSelectObj"
              (filterChangeColumn)="onFilterChangeColumn($event)" [name]="'Lead'"
              (closePopup)="closePopupNew($event)"></calsoft-filter-list-popup>
          </div>
        </div>
      </div>

      <div class="side-form-container" *ngIf="isFilterPanelColumnOpen">
        <div class="side-form-card mat-elevation-z4">
          <div class="side-form-header" fxLayout="row" fxLayoutAlign="space-between center"
            style="padding: 12px 16px; border-bottom: 1px solid #e2e8f0;">
            <h3 style="margin: 0; font-size: 16px; font-weight: 500;">Filter By Column</h3>
            <button mat-icon-button (click)="toggleFilterColumnPanel()" aria-label="Close filter panel">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="filter-panel-body" style="padding: 16px; overflow-y: auto; flex-grow: 1;">
            <calsoft-column-visibility [columns]="columns" [filterType]="true"
              (filterChangeColumn)="onFilterChangeColumn($event)"
              (closePopup)="closePopupTwo($event)"></calsoft-column-visibility>
          </div>
        </div>
      </div>

    </div>

  </div>

</div>